import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThemeSettingsComponent } from './theme-settings/theme-settings.component';
import { EditPartnerSettingsComponent } from './components/edit-partner-theme-settings/edit-partner-settings.component';

const routes: Routes = [
  {
    path: '',
    component: ThemeSettingsComponent
  },
  {
    path: 'temas-parceiro/:id',
    title: 'Tema do Parceiro',
    component: EditPartnerSettingsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ThemeSettingsRoutingModule { }